<template>
  <div>
    <div v-for="(anniversary, index) in _anniversaries" :key="index" class="other-anniversary">
      <TextInput :value="anniversary.name" placeholder="記念日名" @input="value => onInputName(index, value)" />
      <DateInput :value="anniversary.date" @change="date => onChangeDate(index, date)" />
      <Button class="button" :disabled="!canDelete" @click="() => onDelete(index)"><DeleteIcon /></Button>
      <Button
        class="button"
        v-if="_anniversaries.length - 1 === index && _anniversaries.length < 10"
        @click="onAdd"
        :disabled="isDisabledAddBtn(anniversary)"
        ><AddIcon
      /></Button>
    </div>
  </div>
</template>

<script>
import { splitDate } from '@/utils/date'
import Button from '@/components/atoms/Button'
import TextInput from '@/components/atoms/TextInput'
import DateInput from '@/components/molecules/DateInput'
import AddIcon from '@/components/icons/add'
import DeleteIcon from '@/components/icons/delete'

export default {
  name: 'OtherAnniversaries',
  components: {
    Button,
    TextInput,
    DateInput,
    AddIcon,
    DeleteIcon,
  },
  model: {
    prop: 'anniversaries',
    event: 'change',
  },
  props: {
    anniversaries: Array,
  },
  computed: {
    _anniversaries() {
      const anniversaries = this.anniversaries
      return anniversaries && anniversaries.length ? anniversaries : [{}]
    },
    canDelete() {
      return this.anniversaries.length > 0
    },
  },
  methods: {
    isDisabledAddBtn(anniversary) {
      const date = splitDate(anniversary.date)
      return !anniversary.name || !date.month || !date.day
    },
    onInputName(index, name) {
      const anniversaries = [...this._anniversaries]
      anniversaries[index] = { ...anniversaries[index], name }
      this.$emit('change', anniversaries)
    },
    onChangeDate(index, date) {
      const anniversaries = [...this._anniversaries]
      anniversaries[index] = { ...anniversaries[index], date }
      this.$emit('change', anniversaries)
    },
    onAdd() {
      this.$emit('change', this._anniversaries.concat({}))
    },
    onDelete(index) {
      this.$emit(
        'change',
        this._anniversaries.filter((_, i) => i !== index),
      )
    },
  },
}
</script>

<style lang="postcss">
.other-anniversary {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 40px 40px;

  & + & {
    margin-top: 8px;
  }

  :first-child {
    grid-column: 1 / span 3;
  }

  .button {
    height: 40px;
    line-height: 1;
    width: 40px;
  }

  .responsive & {
    @media screen and (--sp-size) {
      grid-gap: 16px;
      grid-template-columns: max-content 1fr;
      grid-template-rows: 40px 40px 40px;

      .date-input {
        grid-column: 1 / 3;
        grid-row: 2;
      }

      & + .other-anniversary {
        margin-top: 16px;
      }

      :first-child {
        grid-column: auto;
      }

      .input-text {
        grid-column: 1 / 3;
        grid-row: 1;
      }
    }
  }
}
</style>
